<template>
  <div id="pdfViewer">
    <div class="pdfMasker"></div>
    <div class="box">
      <i class="close" @click="close()"></i>
      <pdf :src='url' v-for="i in numPages" :key="i" :page="i"></pdf>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
  components: {
    pdf
  },
  props: ['PdfUrl'],
  data () {
    return {
      url: '',
      // url: this.$route.query.url,
      numPages: null
    }
  },
  // mounted () {
  //   this.getPageNumber()
  // },
  watch: {
    PdfUrl (n, o) {
      if (n !== o) {
        this.getPageNumber()
      }
    }
  },
  methods: {
    close () {
      this.$emit('hidePdf', false)
    },
    getPageNumber () {
      this.url = this.PdfUrl
      let loadingTask = pdf.createLoadingTask(this.url)
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages
        this.boxShow = true
      }).catch(err => {
        console.error('pdf 加载失败', err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#pdfViewer {
  height: 100%;
  overflow: hidden;
  .pdfMasker {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
  }
  .box {
    margin: 60px 20px 70px 20px;
    width: calc(100% - 40px);
    height: calc(100% - 130px);
    position: absolute;
    z-index: 11;
    top: 0;
    left: 0;
    overflow-y: auto;
    .close {
      position: fixed;
      top: 70px;
      right: 30px;
      width: 15px;
      height: 15px;
      background: #ffffff;
      border-radius: 50%;
      z-index: 11;
    }
    .close::after {
      width: 100%;
      position: absolute;
      height: 1.5px;
      background: #000;
      content: "";
      top: 7px;
      left: 0;
      transform: rotate(134deg);
      -ms-transform: rotate(134deg);
      -moz-transform: rotate(134deg);
      -webkit-transform: rotate(134deg);
      -o-transform: rotate(134deg);
    }
    .close::before {
      width: 100%;
      position: absolute;
      height: 1.5px;
      background: #000;
      content: "";
      top: 7px;
      right: 0;
      transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      -moz-transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
      -o-transform: rotate(45deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pdfView.vue